<svg
  *ngIf="nin"
  class="nin-verify-icon"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
  (click)="openModal()"
  [title]="'NIN_VERIFICATION.VIEW_DETAILS' | translate"
>
  <path
    d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    fill="#026962"
  />
</svg>

<div class="modal fade" tabindex="-1" #ninModal>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content nin-modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'NIN_VERIFICATION.TITLE' | translate }}</h5>
        <button
          type="button"
          class="btn-close"
          (click)="closeModal()"
        ></button>
      </div>
      <div class="modal-body">
        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2">{{ 'NIN_VERIFICATION.LOADING' | translate }}</p>
        </div>

        <div *ngIf="errorMessage && !loading" class="alert alert-danger">
          {{ errorMessage }}
        </div>

        <div *ngIf="ninData && !loading" class="nin-details">
          <div class="nin-row">
            <div class="label">{{ 'NIN_VERIFICATION.FIRST_NAME' | translate }}</div>
            <div class="value">{{ ninData.firstName }}</div>
          </div>
          <div class="nin-row">
            <div class="label">{{ 'NIN_VERIFICATION.MIDDLE_NAME' | translate }}</div>
            <div class="value">{{ ninData.middleName }}</div>
          </div>
          <div class="nin-row">
            <div class="label">{{ 'NIN_VERIFICATION.SURNAME' | translate }}</div>
            <div class="value">{{ ninData.surname }}</div>
          </div>
          <div class="nin-row">
            <div class="label">{{ 'NIN_VERIFICATION.DATE_OF_BIRTH' | translate }}</div>
            <div class="value">{{ ninData.birthDate | date: 'dd/MM/yyyy' }}</div>
          </div>
          <div class="nin-row">
            <div class="label">{{ 'NIN_VERIFICATION.GENDER' | translate }}</div>
            <div class="value">{{ ninData.gender }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
